(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-how-it-works"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pdp-flow-upload]');
    if (!trigger) return;
    const uploadButton = document.querySelector('.ai-image-generator-start-btn-card .start-btn');
    if (uploadButton) uploadButton.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recent-ai-creations"] && !Shopify.designMode) return;
  try {
    class RecentAiCreations extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedInitialized) return;
      this.isConnectedInitialized = true;
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('.recent-ai-creations__launcher');
      this.closeButton = this.querySelector('.recent-ai-creations__close');
      this.grid = this.querySelector('.recent-ai-creations__grid');
      this.empty = this.querySelector('.recent-ai-creations__empty');
      this.loading = this.querySelector('.recent-ai-creations__loading');
      this.count = this.querySelector('.recent-ai-creations__count');
      this.refreshRevision = 0;
      this.handleLatestGenerated = () => {
        window.clearTimeout(this.latestGeneratedRefreshTimer);
        this.latestGeneratedRefreshTimer = window.setTimeout(() => this.refresh(), 700);
      };
      this.handleHistoryUpdated = async () => {
        window.clearTimeout(this.latestGeneratedRefreshTimer);
        await this.refresh();
        this.launcher.classList.remove('is-updated');
        requestAnimationFrame(() => this.launcher.classList.add('is-updated'));
      };
      this.handleLauncherClick = () => this.open();
      this.handleCloseClick = () => this.dialog.close();
      this.handleStorageChange = (event) => {
        if (!event.key || (event.key.startsWith('ai_image_preview_v1:') && event.key.endsWith(':history'))) {
          this.refresh();
        }
      };
      this.handlePageShow = () => this.refresh();
      this.handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') this.refresh();
      };
      this.handleDialogClick = (event) => {
        if (event.target === this.dialog) this.dialog.close();
      };
      this.launcher.addEventListener('click', this.handleLauncherClick);
      this.closeButton.addEventListener('click', this.handleCloseClick);
      this.dialog.addEventListener('click', this.handleDialogClick);
      document.addEventListener('ai-image:latest-generated', this.handleLatestGenerated);
      document.addEventListener('ai-image:history-updated', this.handleHistoryUpdated);
      window.addEventListener('storage', this.handleStorageChange);
      window.addEventListener('pageshow', this.handlePageShow);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.refresh();
    }

    disconnectedCallback() {
      if (!this.isConnectedInitialized) return;
      window.clearTimeout(this.latestGeneratedRefreshTimer);
      this.launcher?.removeEventListener('click', this.handleLauncherClick);
      this.closeButton?.removeEventListener('click', this.handleCloseClick);
      this.dialog?.removeEventListener('click', this.handleDialogClick);
      document.removeEventListener('ai-image:latest-generated', this.handleLatestGenerated);
      document.removeEventListener('ai-image:history-updated', this.handleHistoryUpdated);
      window.removeEventListener('storage', this.handleStorageChange);
      window.removeEventListener('pageshow', this.handlePageShow);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.isConnectedInitialized = false;
    }

    async open() {
      if (!this.dialog.open) this.dialog.showModal();
      this.setLoading(true);
      await this.waitForPendingHistoryWrites();
      await this.refresh().finally(() => this.setLoading(false));
    }

    async waitForPendingHistoryWrites() {
      const pendingWrite = window.aiImageGenerator?.historyWritePromise;
      if (!pendingWrite || typeof pendingWrite.then !== 'function') return;
      try {
        await pendingWrite;
      } catch (_) {}
    }

    setLoading(isLoading) {
      this.loading.hidden = !isLoading;
      this.grid.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    async refresh() {
      const revision = ++this.refreshRevision;
      const entries = await this.readEntries();
      if (revision !== this.refreshRevision) return;
      this.render(entries);
    }

    openDatabase() {
      return new Promise((resolve, reject) => {
        const request = window.indexedDB.open('ai_image_generator_db', 1);
        request.onupgradeneeded = (event) => {
          const database = event.target.result;
          if (!database.objectStoreNames.contains('preview_state')) {
            database.createObjectStore('preview_state', { keyPath: 'storageKey' });
          }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });
    }

    async readEntries() {
      const records = [];
      if (window.indexedDB) {
        try {
          const database = await this.openDatabase();
          const indexedDbRecords = await new Promise((resolve, reject) => {
            const transaction = database.transaction('preview_state', 'readonly');
            const request = transaction.objectStore('preview_state').getAll();
            request.onsuccess = () => resolve(request.result || []);
            request.onerror = () => reject(request.error);
          });
          records.push(...indexedDbRecords);
          database.close();
        } catch (error) {
          console.error('Unable to read recent creations from IndexedDB:', error);
        }
      }

      try {
        for (let index = 0; index < localStorage.length; index += 1) {
          const storageKey = localStorage.key(index);
          if (!storageKey?.startsWith('ai_image_preview_v1:') || !storageKey.endsWith(':history')) continue;
          const payload = JSON.parse(localStorage.getItem(storageKey) || '[]');
          if (Array.isArray(payload)) records.push({ storageKey, payload });
        }
      } catch (error) {
        console.error('Unable to read recent creations from local storage:', error);
      }

      const entries = records
        .filter((record) => record.storageKey?.startsWith('ai_image_preview_v1:') && record.storageKey.endsWith(':history'))
        .flatMap((record) => {
          const productUrl = record.storageKey.slice('ai_image_preview_v1:'.length, -':history'.length);
          return Array.isArray(record.payload)
            ? record.payload.map((item) => ({ ...item, productUrl, storageKey: record.storageKey }))
            : [];
        })
        .filter((item) => item.previewUrl && item.productUrl.startsWith('/products/'))
        .sort((left, right) => (right.savedAt || 0) - (left.savedAt || 0));

      const seen = new Set();
      return entries.filter((entry) => {
        const identity = `${entry.productUrl}:${entry.previewUrl}`;
        if (seen.has(identity)) return false;
        seen.add(identity);
        return true;
      });
    }

    async getProductVariants(entry) {
      this.productVariantsPromises ||= new Map();
      const cached = this.productVariantsPromises.get(entry.productUrl);
      if (cached) return cached;

      const request = fetch(`${entry.productUrl}.js`, {
        headers: { Accept: 'application/json' }
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => product?.variants || [])
        .catch(() => []);
      this.productVariantsPromises.set(entry.productUrl, request);
      return request;
    }

    async resolveVariantId(entry, selectedVariantId = '') {
      if (selectedVariantId) return selectedVariantId;
      if (entry.variantId) return entry.variantId;

      if (window.location.pathname === entry.productUrl) {
        const currentVariantId = document.querySelector('product-form form[action*="/cart/add"] [name="id"]')?.value;
        if (currentVariantId) return currentVariantId;
      }

      const variants = await this.getProductVariants(entry);
      return variants.find((variant) => variant.available)?.id || '';
    }

    getCartSectionIds(cart) {
      const sectionIds = cart?.getSectionsToRender?.().map((section) => section.id) || [];
      if (document.getElementById('cart-icon-bubble')) sectionIds.push('cart-icon-bubble');
      if (document.querySelector('cart-drawer')) sectionIds.push('cart-drawer');
      return [...new Set(sectionIds)];
    }

    renderCartIcon(sectionHtml) {
      if (!sectionHtml) return;
      const currentIcon = document.getElementById('cart-icon-bubble');
      const nextSection = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('.shopify-section');
      if (currentIcon && nextSection) currentIcon.innerHTML = nextSection.innerHTML;
    }

    async fetchCartSections(sectionIds) {
      if (!sectionIds.length) return null;
      const sectionUrl = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
      sectionUrl.searchParams.set('sections', sectionIds.join(','));
      try {
        const response = await fetch(sectionUrl, {
          cache: 'no-store',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        return response.ok ? await response.json() : null;
      } catch (error) {
        console.error('Unable to refresh cart sections:', error);
        return null;
      }
    }

    getCartProperties(entry) {
      return {
        ...(entry.cartProperties || {}),
        'Watermark Image URL': entry.watermarkUrl || entry.previewUrl,
        ...(entry.referenceImageUrl ? { 'Reference Image': entry.referenceImageUrl } : {})
      };
    }

    async hideAddedCard(button) {
      const card = button.closest('.recent-ai-creations__card');
      if (!card) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduceMotion) {
        card.classList.add('is-removing');
        await new Promise((resolve) => window.setTimeout(resolve, 420));
      }
      card.remove();
      const remainingCount = this.grid.children.length;
      this.hidden = remainingCount === 0;
      this.empty.hidden = remainingCount !== 0;
      this.count.hidden = remainingCount === 0;
      this.count.textContent = String(remainingCount);
    }

    async deleteStoredEntry(entry) {
      const matchesEntry = (item) => entry.id
        ? item.id === entry.id
        : item.previewUrl === entry.previewUrl;

      try {
        const database = await this.openDatabase();
        const record = await new Promise((resolve, reject) => {
          const transaction = database.transaction('preview_state', 'readonly');
          const request = transaction.objectStore('preview_state').get(entry.storageKey);
          request.onsuccess = () => resolve(request.result);
          request.onerror = () => reject(request.error);
        });

        if (record && Array.isArray(record.payload)) {
          const nextPayload = record.payload.filter((item) => !matchesEntry(item));
          await new Promise((resolve, reject) => {
            const transaction = database.transaction('preview_state', 'readwrite');
            const store = transaction.objectStore('preview_state');
            if (nextPayload.length) {
              store.put({ ...record, payload: nextPayload });
            } else {
              store.delete(entry.storageKey);
            }
            transaction.oncomplete = () => resolve();
            transaction.onerror = () => reject(transaction.error);
            transaction.onabort = () => reject(transaction.error);
          });
          database.close();
          return true;
        }
        database.close();
      } catch (error) {
        console.error('Unable to delete recent creation from IndexedDB:', error);
      }

      try {
        const storedPayload = JSON.parse(localStorage.getItem(entry.storageKey) || '[]');
        if (!Array.isArray(storedPayload)) return false;
        const nextPayload = storedPayload.filter((item) => !matchesEntry(item));
        if (nextPayload.length) {
          localStorage.setItem(entry.storageKey, JSON.stringify(nextPayload));
        } else {
          localStorage.removeItem(entry.storageKey);
        }
        return nextPayload.length !== storedPayload.length;
      } catch (error) {
        console.error('Unable to delete recent creation from local storage:', error);
        return false;
      }
    }

    async deleteEntry(entry, button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = '<span class="recent-ai-creations__delete-spinner" aria-hidden="true"></span>';
      const [deleted] = await Promise.all([
        this.deleteStoredEntry(entry),
        new Promise((resolve) => window.setTimeout(resolve, 180))
      ]);
      if (!deleted) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        return;
      }
      await this.hideAddedCard(button);
      document.dispatchEvent(new CustomEvent('ai-image:history-updated', {
        detail: { storageKey: entry.storageKey }
      }));
    }

    async addEntryToCart(entry, button, selectedVariantId = '') {
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      try {
        const variantId = await this.resolveVariantId(entry, selectedVariantId);
        if (!variantId) {
          window.location.assign(entry.productUrl);
          return;
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = new FormData();
        body.append('id', String(variantId));
        body.append('quantity', '1');
        Object.entries(this.getCartProperties(entry)).forEach(([name, value]) => {
          if (String(value || '').trim()) body.append(`properties[${name}]`, String(value));
        });
        const sectionIds = this.getCartSectionIds(cart);
        cart?.setActiveElement?.(button);
        if (sectionIds.length) {
          body.append('sections', sectionIds);
          body.append('sections_url', window.location.pathname);
        }

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body
        });
        const responseText = await response.text();
        let result = {};
        try {
          result = JSON.parse(responseText);
        } catch (error) {
          if (!response.ok) console.error('Unable to parse cart response:', error);
        }
        if (result.status) throw new Error(result.description || result.message || 'Cart request failed');

        const missingSections = sectionIds.some((sectionId) => !result.sections?.[sectionId]);
        const refreshedSections = missingSections ? await this.fetchCartSections(sectionIds) : null;
        if (!response.ok && !refreshedSections) throw new Error(result.description || result.message || 'Cart request failed');
        const cartData = {
          ...result,
          sections: {
            ...(result.sections || {}),
            ...(refreshedSections || {})
          }
        };

        if (this.dialog.open) this.dialog.close();
        try {
          cart?.renderContents?.(cartData);
        } catch (renderError) {
          console.error('Unable to render updated cart:', renderError);
        }
        if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
        this.renderCartIcon(cartData.sections?.['cart-icon-bubble']);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'recent-ai-creations',
            productVariantId: String(variantId),
            cartData
          });
        }
        button.classList.add('is-added');
        window.setTimeout(() => {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1800);
      } catch (error) {
        console.error('Unable to add recent creation to cart:', error);
        button.disabled = false;
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    }

    async addVariantSelector(entry, actions, button) {
      const variants = await this.getProductVariants(entry);
      if (!actions.isConnected || variants.length <= 1) return;

      const firstAvailableVariant = variants.find((variant) => variant.available);
      if (!firstAvailableVariant) {
        button.disabled = true;
        return;
      }

      const select = document.createElement('select');
      select.className = 'recent-ai-creations__variant-select';
      variants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.title;
        option.disabled = !variant.available;
        select.appendChild(option);
      });
      select.value = String(firstAvailableVariant.id);
      actions.classList.add('has-variants');
      actions.prepend(select);
      button._recentAiVariantSelect = select;
    }

    openPreview(entry, entries) {
      const galleryItems = entries
        .map((item, index) => ({
          src: item.watermarkUrl || item.previewUrl,
          thumbSrc: item.watermarkUrl || item.previewUrl,
          type: 'image',
          caption: `${this.dataset.galleryLabel} ${index + 1} / ${entries.length}`
        }))
        .filter((item) => item.src);
      const currentUrl = entry.watermarkUrl || entry.previewUrl;
      const startIndex = Math.max(0, galleryItems.findIndex((item) => item.src === currentUrl));

      if (this.dialog.open) this.dialog.close();
      if (window.Fancybox?.show) {
        window.Fancybox.show(galleryItems, {
          startIndex,
          wheel: 'slide'
        });
        return;
      }
      window.open(currentUrl, '_blank', 'noopener');
    }

    render(entries) {
      this.grid.replaceChildren();
      this.hidden = entries.length === 0;
      this.empty.hidden = entries.length !== 0;
      this.count.hidden = entries.length === 0;
      this.count.textContent = String(entries.length);

      if (!entries.length) return;
      const fragment = document.createDocumentFragment();
      entries.forEach((entry, index) => {
        const card = document.createElement('article');
        const link = document.createElement('a');
        const image = document.createElement('img');
        const previewButton = document.createElement('button');
        const deleteButton = document.createElement('button');
        const cartActions = document.createElement('div');
        const addToCart = document.createElement('button');
        card.className = 'recent-ai-creations__card';
        card.setAttribute('role', 'listitem');
        link.className = 'recent-ai-creations__card-link';
        link.href = entry.productUrl;
        link.setAttribute('aria-label', this.dataset.viewProductLabel);
        image.src = entry.watermarkUrl || entry.previewUrl;
        image.alt = '';
        image.loading = index < 4 ? 'eager' : 'lazy';
        image.decoding = 'async';
        previewButton.type = 'button';
        previewButton.className = 'recent-ai-creations__preview';
        previewButton.setAttribute('aria-label', `${this.dataset.previewLabel} ${index + 1}`);
        previewButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="1.8"/><path d="m15 15 4 4M10.5 8v5M8 10.5h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
        previewButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.openPreview(entry, entries);
        });
        deleteButton.type = 'button';
        deleteButton.className = 'recent-ai-creations__delete';
        deleteButton.setAttribute('aria-label', this.dataset.deleteLabel);
        deleteButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        deleteButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.deleteEntry(entry, deleteButton);
        });
        addToCart.type = 'button';
        addToCart.className = 'recent-ai-creations__add-to-cart';
        addToCart.setAttribute('aria-label', this.dataset.addToCartLabel);
        addToCart.setAttribute('title', this.dataset.addToCartLabel);
        addToCart.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true"><path fill-rule="evenodd" d="M.5 1.75a.75.75 0 0 1 .75-.75h1.612a1.75 1.75 0 0 1 1.732 1.5h9.656a.75.75 0 0 1 .748.808l-.358 4.653a2.75 2.75 0 0 1-2.742 2.539h-6.351l.093.78a.25.25 0 0 0 .248.22h6.362a.75.75 0 0 1 0 1.5h-6.362a1.75 1.75 0 0 1-1.738-1.543l-1.04-8.737a.25.25 0 0 0-.248-.22h-1.612a.75.75 0 0 1-.75-.75m4.868 7.25h6.53a1.25 1.25 0 0 0 1.246-1.154l.296-3.846h-8.667zm2.632 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"></path></svg>';
        addToCart.addEventListener('click', () => {
          this.addEntryToCart(entry, addToCart, addToCart._recentAiVariantSelect?.value || '');
        });
        cartActions.className = 'recent-ai-creations__cart-actions';
        cartActions.append(addToCart);
        link.append(image);
        card.append(link, previewButton, deleteButton, cartActions);
        fragment.append(card);
        this.addVariantSelector(entry, cartActions, addToCart);
      });
      this.grid.append(fragment);
    }
  }

  if (!customElements.get('recent-ai-creations')) {
    customElements.define('recent-ai-creations', RecentAiCreations);
  }
  } catch(e) { console.error(e); }
})();

})();
